<template>
  <b-card>
    <b-form class="mt-2" @submit.prevent="saveChange">
      <b-row>
        <b-col sm="12">
          <!-- <b-form-group :label="$i18n.t('Nome do robô')" label-for="robotName">
            <b-form-input v-model="robotName" name="robotName" disabled />
          </b-form-group>
          <b-form-group :label="$i18n.t('ID do robô')" label-for="idRobot">
            <b-form-input v-model="idRobot" name="idRobot" disabled />
          </b-form-group>
          <b-form-group :label="$i18n.t('Percentual médio de lucro ou prejuízo em cada trade')" label-for="profit">
            <b-form-input v-model="profit" name="profit" />
            <small class="text-warning">O cálculo deste campo é x100 - exemplo 0.001 = 0.1%</small>
          </b-form-group>
          <b-form-group :label="$i18n.t('Taxa de acerto')" label-for="hitHate">
            <b-form-input v-model="hitHate" name="hitHate" />
          </b-form-group>
          <b-form-group :label="$i18n.t('Percentual do balanço alocado em cada trade')" label-for="amountTrade">
            <b-form-input v-model="amountTrade" name="amountTrade" />
          </b-form-group> -->
          <b-form-group :label="$i18n.t('Status do robô')" label-for="status">
            <b-form-input v-model="status" name="status" />
            <small class="text-warning">0 - para desativado | 1 - para ativado</small>
          </b-form-group>
          <b-form-group :label="$i18n.t('Objetivo de ganho diário')" label-for="goal">
            <b-form-input v-model="goal" name="goal" />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-button type="submit" variant="primary" class="mt-2 mr-1" :disabled="loading">
            <div v-if="!loading">
              {{ $t("Salvar alterações") }}
            </div>
            <div v-else>
              <b-spinner small type="grow"></b-spinner>
              {{ $t("Carregando...") }}
            </div>
          </b-button>
          <b-button variant="outline-secondary" type="reset" class="mt-2" @click.prevent="resetForm">
            {{ $t("Redefinir") }}
          </b-button>
          <alert class="mt-1" :text="textAlert" :color="colorAlert" :showAlert="showAlert"
            @changeVariableAlert="(val) => (showAlert = val)" />
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      robotName: "SatoBot",
      idRobot: "",
      profit: 0.001,
      hitHate: 70,
      amountTrade: 3,
      goal: 1.5,
      status: 0,

      loading: false,
      showAlert: false,
      textAlert: "",
      colorAlert: "warning",
    };
  },
  mounted() {
    this.getRobotConfig()
  },
  methods: {
    getRobotConfig() {
      this.$store.dispatch('searchConfigRobot').then(resp => {
        this.idRobot = resp.config[0].idRobot
        this.profit = resp.config[0].profit
        this.hitHate = resp.config[0].hitHate
        this.amountTrade = resp.config[0].amountTrade
        this.goal = resp.config[0].goal
        this.status = resp.config[0].status
      })
    },
    saveChange() {
      this.loading = true;
      const config = {
        idRobot: this.idRobot,
        profit: this.profit,
        hitHate: this.hitHate,
        amountTrade: this.amountTrade,
        goal: this.goal,
        status: this.status
      };
      this.$store
        .dispatch("changeConfigRobot", config)
        .then((resp) => {
          this.showAlert = true;
          this.colorAlert = "success";
          this.textAlert = this.$i18n.t(
            "Configurações do robô trader atualizadas."
          );
          this.loading = false;
        })
        .catch((err) => {
          this.showAlert = true;
          this.colorAlert = "danger";
          this.textAlert = err;
          this.loading = false;
        });
    },
  },
};
</script>